<template>
  <div class="comContent">
    <div class="search-from">
      <el-form ref="searchForm" :inline="true" style="text-align: left">
        <el-row>
          <el-col :span="12">
            <el-tabs v-model="searchForm.status" class="headerTabs" @tab-click="handleClick">
              <el-tab-pane :label="item.label" v-for="(item, index) in tabsList" :key="index" :name="item.name">
                <span v-if="item.value > 0" slot="label">
                  {{ item.label }}
                  <el-badge :value="item.value" class="item" />
                </span>
              </el-tab-pane>
            </el-tabs>
          </el-col>

          <el-col :span="12" style="margin-top: 16px;" class="flex-rt">
            <el-form-item>
              <el-input v-model.trim="searchForm.orderCode" placeholder="订单编号" clearable maxlength="20" size="small"
                style="width: 120px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="searchForm.createBy" placeholder="申请人" clearable maxlength="20" size="small"
                style="width: 120px" />
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="reset('searchForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <div class="content">
      <myTable :table-data="tableData" :index="index" :selection="false" :page="page" :showpage="true" :operation="false"
        v-loading="loading" :table-option.sync="tableOption" @page-change="getList" :expand="false">
        <template slot="operation" slot-scope="scope">
          <div style="margin: 0 0px">
            <el-link type="primary" :underline="false" @click="checkDetails(scope.row, 1)" style="margin-right: 10px">
              查看详情
            </el-link>
          </div>
        </template>
        <template slot="status" slot-scope="scope">
          <span v-if="scope.row.status =='0'"> 待处理 </span> 
          <span v-if="scope.row.status =='1'"> 通过 </span> 
          <span v-if="scope.row.status =='2'"> 驳回 </span> 
        </template>
      </myTable>
    </div>
    <CommentOrder ref="commentOrder" @get-list="getList"></CommentOrder>
  </div>
</template>
<script>
import myTable from "@/components/myTable";
import avater from "/public/img/default.png";
import { mapGetters } from "vuex";
import { examineList } from "@/api/businessManage"
import Tabs from '@/components/Tabs'
import CommentOrder from "@/components/CommentOrder";
export default {
  components: { myTable, Tabs ,CommentOrder},
  props: {},
  data() {
    return {
      activeName: '1',
      dialogVisible: false,
      loading: false,
      avater: avater,
      searchForm: {
        status:'0',
      },
      tableData: [],
      operation: false,
      selection: true,
      index: false, 
      tabsList: [ // tabs 传的值
        {
          name: '0',
          label: '待处理',
          value: 0,
        },
        {
          name: '1',
          label: '通过',
          value: 0,
        },
        {
          name: '2',
          label: '驳回',
          value: 0,
        },
      ],
      tableOption: [
        { label: "申请人", prop: "createBy" },
        { label: "提交时间", prop: "createTime" },
        { label: "订单编号", prop: "orderCode" },
        { label: "状态", prop: "status",slot:true },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width:100,
          fixed: "right",
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      isReport: true,
    };
  },
  filters: {},
  created() { },
  mounted() {
    this.getList()
  },
  computed: {
    // ...mapGetters(["permissions"]),
  },
  methods: {
    
    checkDetails(row){
      this.$refs['commentOrder'].dialogVisible = true; 
      this.$refs['commentOrder'].formData.id = row.id;
      this.$refs['commentOrder'].getDetail(row);
    },
    handleClick() { 
      this.getList(1);
    },
    // 查询列表
    getList(current) {
      const params = Object.assign({}, this.searchForm);
      params.size = this.page.size;
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      examineList(params).then((res) => {  
        if(res.code ==0){
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      }).catch((err) => {
      })
    },

    reset() {
      this.page.current = 1;
      this.searchForm = {};
      this.searchForm.status ='0';
      this.getList(1);
    },

    handleClose() {
      this.dialogVisible = false;
    },
    submit() { },
  },
};
</script>
<style lang="scss" scoped>
.flex-rt {
  display: flex;
  justify-content: flex-end;
}

.search-from {
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}
</style>
